<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="internal" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
        <el-form-item v-if="isBlogAdmin" slot="buttonSlot">
          <el-button type="warning" icon="el-icon-upload2" @click="openSimulateDialog">模拟上报</el-button>
        </el-form-item>
      </toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" size="medium" style="width: 100%" class="custom-tbl teacher-kq-tbl" height="100%">
        <el-table-column prop="TeacherName" label="姓名" min-width="100"></el-table-column>
        <el-table-column prop="DeptName" label="部门" min-width="120"></el-table-column>
        <el-table-column prop="TouchTime" label="打卡时间" min-width="160"></el-table-column>
        <el-table-column prop="ReportTime" label="上报时间" min-width="160"></el-table-column>
        <el-table-column prop="TouchType" label="方向" width="80">
          <template slot-scope="scope">
            <span :style="{ color: getTouchTypeColor(scope.row.TouchType) }">{{ scope.row.TouchType || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="RegStatus" label="状态" width="80">
          <template slot-scope="scope">
            <span :style="{ color: getRegStatusColor(scope.row.RegStatus) }">{{ scope.row.RegStatus || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="打卡位置" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.TouchPosition || scope.row.KqTerminalId || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="ProcessResult" label="处理说明" min-width="140"></el-table-column>
        <el-table-column prop="IsAbnormal" label="异常" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.IsAbnormal" style="color: #f56c6c">异常</span>
          </template>
        </el-table-column>
        <el-table-column prop="KqImageFile" label="媒体文件" align="center" header-align="center" min-width="120">
          <template slot-scope="scope">
            <oss-media-thumbs :media="scope.row.KqImageFile" />
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="pageSize" :total="total" style="float: right"></el-pagination>
      </el-col>
    </section>

    <!-- 模拟上报弹窗：仅 blogadmin / admin -->
    <el-dialog
      title="模拟教师考勤上报"
      :visible.sync="simulateVisible"
      width="520px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="simulateForm" :model="simulateForm" :rules="simulateRules" label-width="96px" size="small">
        <el-form-item label="考勤终端" prop="KqTerminalId">
          <el-select
            v-model="simulateForm.KqTerminalId"
            filterable
            clearable
            placeholder="选择考勤终端"
            style="width: 100%"
            @change="onTerminalChange"
          >
            <el-option
              v-for="d in terminalOptions"
              :key="d.KqTerminalId"
              :label="(d.TerminalName || d.KqTerminalId) + '（' + d.KqTerminalId + '）'"
              :value="d.KqTerminalId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="教师" prop="UserId">
          <el-select
            v-model="simulateForm.UserId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="输入姓名搜索（至少2字）"
            :remote-method="searchTeachers"
            :loading="teacherLoading"
            :no-data-text="teacherSearchHint"
            style="width: 100%"
            @change="onTeacherChange"
            @visible-change="onTeacherSelectVisible"
          >
            <el-option
              v-for="t in teacherOptions"
              :key="t.Id"
              :label="formatTeacherOption(t)"
              :value="String(t.Id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="方向" prop="TouchType">
          <el-radio-group v-model="simulateForm.TouchType">
            <el-radio label="in">进入</el-radio>
            <el-radio label="out">离开</el-radio>
            <el-radio label="inout">出入</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="刷卡时间" prop="TouchTime">
          <el-date-picker
            v-model="simulateForm.TouchTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择刷卡时间"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="simulateVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="simulateLoading" @click="submitSimulate">提交上报</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { getTeacherRecordDetail, exportTeacherRecordDetail } from "../../api/teacherAttendance";
import { getKqtDeviceTerminalListPage, simulateKqtReportAttendance } from "../../api/modules/attendance";
import { getTeacherMasterListPage } from "../../api/modules/personnel";
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";
import superAdminMixin from "../../mixins/superAdminMixin";

export default {
  components: { Toolbar, DepartmentPane },
  mixins: [superAdminMixin],
  data() {
    return {
      filters: {},
      searchList: [
        { label: "选择校区", key: "campusId", type: "select", clearable: true, options: [] },
        { label: "姓名", key: "name" },
        { label: "开始日期", key: "date", type: "date" },
        { label: "结束日期", key: "endDate", type: "date" },
      ],
      buttonList: [],
      users: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      DepartmentId: 0,
      currentUser: null,
      simulateVisible: false,
      simulateLoading: false,
      terminalOptions: [],
      teacherOptions: [],
      teacherLoading: false,
      teacherSearchHint: "请输入关键字搜索",
      simulateForm: {
        KqTerminalId: "",
        UserId: "",
        CardId: "",
        TouchType: "in",
        TouchTime: "",
      },
      simulateRules: {
        KqTerminalId: [{ required: true, message: "请选择考勤终端", trigger: "change" }],
        UserId: [{ required: true, message: "请选择教师", trigger: "change" }],
        TouchType: [{ required: true, message: "请选择方向", trigger: "change" }],
        TouchTime: [{ required: true, message: "请选择刷卡时间", trigger: "change" }],
      },
    };
  },
  computed: {
    schoolDepartmentId() {
      return this.resolveSchoolId();
    },
  },
  methods: {
    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.clearCampusFilter();
      this.loadCampusOptions();
      this.page = 1;
      this.handleQuery(false);
    },
    /** 取顶部当前学校 ID（校区列表必须按学校加载，不能用内部部门 ID）。 */
    resolveSchoolId() {
      const candidates = [
        this.$store.state.activeSchoolId,
        typeof window !== 'undefined' ? window.localStorage.getItem('activeSchoolId') : '',
      ];
      return candidates.find((id) => /^\d+$/.test(String(id || '')) && String(id) !== '0') || '';
    },
    /** 清空工具栏校区筛选（切换学校时防止残留旧校区）。最后更新：2026-08-30 */
    clearCampusFilter() {
      this.filters = { ...(this.filters || {}), campusId: null };
      const campusSearch = this.searchList.find((e) => e.key === 'campusId');
      if (campusSearch) campusSearch.options = [];
      if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
        this.$set(this.$refs.toolbar.searchObj, 'campusId', null);
      }
    },
    /** 顶部学校切换后重载校区。最后更新：2026-08-30 */
    onActiveSchoolChange(newSchoolId, oldSchoolId) {
      if (String(newSchoolId || '') === String(oldSchoolId || '')) return;
      this.clearCampusFilter();
      this.users = [];
      this.total = 0;
      this.page = 1;
      this.DepartmentId = 0;
      this.loadCampusOptions();
    },
    loadCampusOptions() {
      const schoolId = this.resolveSchoolId();
      if (!schoolId) {
        const campusSearch = this.searchList.find((e) => e.key === 'campusId');
        if (campusSearch) campusSearch.options = [];
        return;
      }
      getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then((res) => {
        if (String(schoolId) !== String(this.resolveSchoolId())) return;
        if (!res.data.success) return;
        const list = res.data.response.data || [];
        const options = list.map((d) => ({ label: d.Name, value: d.Id }));
        const campusSearch = this.searchList.find((e) => e.key === 'campusId');
        if (campusSearch) campusSearch.options = options;
      });
    },
    callFunction(item) {
      if (typeof item.search === "object") {
        this.filters = item.search;
      }
      this[item.Func] && this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery(false);
    },
    buildQueryParams(withPage = true) {
      const para = {
        departmentId: this.filters.campusId || this.DepartmentId || "",
        name: this.filters.name,
        date: this.filters.date,
        endDate: this.filters.endDate,
      };
      if (withPage) {
        para.page = this.page;
        para.intPageSize = this.pageSize;
      }
      return para;
    },
    handleQuery(resetPage = true) {
      if (resetPage) this.page = 1;
      const para = this.buildQueryParams(true);
      this.listLoading = true;
      getTeacherRecordDetail(para).then(async (res) => {
        if (!res.data.success) {
          this.$message({ message: res.data.msg || "查询失败", type: "error" });
          this.listLoading = false;
          return;
        }
        const resp = res.data.response || {};
        this.total = resp.dataCount || 0;
        const rows = resp.data || [];
        await this.prefetchListOssMedia(rows, "KqImageFile");
        this.users = rows;
        this.listLoading = false;
      }).catch(() => {
        this.listLoading = false;
      });
    },
    async parseBlobJsonMsg(blob) {
      try {
        const text = await blob.text();
        const j = JSON.parse(text);
        return (j && (j.msg || j.message)) || "";
      } catch (e) {
        return "";
      }
    },
    /** 导出当前筛选条件下的教师打卡明细。创建于 2026-09-24 */
    async exportExcel() {
      const para = this.buildQueryParams(false);
      const fileName = `教师考勤明细_${para.date || "all"}_${para.endDate || para.date || "all"}`;
      try {
        const response = await exportTeacherRecordDetail(para);
        if (!response || typeof response.status !== "number" || !response.config) {
          const msg = (response && (response.msg || response.message)) || "导出失败";
          this.$message.error(msg);
          return;
        }
        const ct =
          (response.headers &&
            (response.headers["content-type"] || response.headers["Content-Type"])) ||
          "";
        if (ct.includes("application/json")) {
          const msg = await this.parseBlobJsonMsg(response.data);
          this.$message.error(msg || "导出失败");
          return;
        }
        if (!response.data || (response.data.size != null && response.data.size === 0)) {
          this.$message.warning("导出数据为空");
          return;
        }
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName + ".xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        const blob = error.response && error.response.data;
        if (blob instanceof Blob) {
          const msg = await this.parseBlobJsonMsg(blob);
          this.$message.error(msg || "导出失败");
          return;
        }
        this.$message.error("导出失败，请稍后重试");
      }
    },
    getRegStatusColor(status) {
      const map = { 正常: "#67c23a", 迟到: "#e6a23c", 早退: "#f56c6c", 缺勤: "#f56c6c" };
      return map[status] || "";
    },
    getTouchTypeColor(type) {
      if (type === "进入") return "#67c23a";
      if (type === "离开") return "#e6a23c";
      return "";
    },
    formatNow() {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    formatTeacherOption(t) {
      if (!t) return "";
      const name = t.TeacherName || t.teacherName || "";
      const workNo = t.WorkNumber || t.workNumber || "";
      const card = t.CardNumber || t.cardNumber || "";
      const parts = [name];
      if (workNo) parts.push(`工号${workNo}`);
      if (card) parts.push(`卡${card}`);
      return parts.join(" / ");
    },
    async openSimulateDialog() {
      if (!this.isBlogAdmin) return;
      this.simulateForm = {
        KqTerminalId: "",
        UserId: "",
        CardId: "",
        TouchType: "in",
        TouchTime: this.formatNow(),
      };
      this.teacherOptions = [];
      this.teacherSearchHint = "请输入关键字搜索";
      this.simulateVisible = true;
      await this.loadTerminals();
    },
    onTeacherSelectVisible(visible) {
      if (!visible) return;
      if (!this.teacherOptions.length) {
        this.teacherSearchHint = "请输入姓名（至少2字）";
      }
    },
    async loadTerminals() {
      const res = await getKqtDeviceTerminalListPage({
        page: 1,
        intPageSize: 200,
        type: "0",
        departmentId: this.schoolDepartmentId || undefined,
      });
      this.terminalOptions = (res.data && res.data.response && res.data.response.data) || [];
      if (!this.simulateForm.KqTerminalId && this.terminalOptions.length) {
        this.simulateForm.KqTerminalId = this.terminalOptions[0].KqTerminalId;
        this.onTerminalChange(this.simulateForm.KqTerminalId);
      }
    },
    onTerminalChange(id) {
      const d = (this.terminalOptions || []).find((x) => x.KqTerminalId === id);
      if (d && d.TouchTypeDirection && ["in", "out", "inout"].includes(d.TouchTypeDirection)) {
        this.simulateForm.TouchType = d.TouchTypeDirection;
      }
    },
    /** 远程搜索教师主档：关键字至少 2 字，最多 30 条。创建于 2026-09-24 */
    async searchTeachers(query) {
      const q = (query || "").trim();
      if (q.length < 2) {
        this.teacherOptions = [];
        this.teacherSearchHint = q ? "请再输入至少1个字" : "请输入姓名（至少2字）";
        return;
      }
      this.teacherLoading = true;
      this.teacherSearchHint = "无匹配教师";
      try {
        const para = {
          page: 1,
          intPageSize: 30,
          teacherName: q,
          departmentId: this.schoolDepartmentId || this.DepartmentId || undefined,
        };
        const res = await getTeacherMasterListPage(para);
        const list = (res.data && res.data.response && res.data.response.data) || [];
        this.teacherOptions = list;
        if (!list.length) this.teacherSearchHint = "无匹配教师";
      } finally {
        this.teacherLoading = false;
      }
    },
    onTeacherChange(userId) {
      const t = (this.teacherOptions || []).find((x) => String(x.Id) === String(userId));
      this.simulateForm.CardId = t ? String(t.CardNumber || t.cardNumber || "").trim() : "";
    },
    submitSimulate() {
      this.$refs.simulateForm.validate(async (ok) => {
        if (!ok) return;
        if (!this.simulateForm.UserId && !this.simulateForm.CardId) {
          this.$message.warning("请选择教师");
          return;
        }
        this.simulateLoading = true;
        try {
          const touchTime = this.simulateForm.TouchTime;
          const res = await simulateKqtReportAttendance(
            {
              UserId: this.simulateForm.UserId || "",
              CardId: this.simulateForm.CardId || "",
              KqTerminalId: this.simulateForm.KqTerminalId,
              TouchType: this.simulateForm.TouchType,
              TouchTime: touchTime,
              ReportTime: touchTime,
              UserRole: "teacher",
              BusinessDesc: "教师模拟上报",
            },
            { skipCache: true }
          );
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || "模拟上报成功");
            this.simulateVisible = false;
            this.handleQuery();
          } else {
            this.$message.error((res.data && res.data.msg) || "模拟上报失败");
          }
        } catch (e) {
          this.$message.error("模拟上报请求失败");
        } finally {
          this.simulateLoading = false;
        }
      });
    },
  },
  watch: {
    "$store.state.activeSchoolId"(newSchoolId, oldSchoolId) {
      this.onActiveSchoolChange(newSchoolId, oldSchoolId);
    },
  },
  mounted() {
    if (window.localStorage.user) {
      try {
        this.currentUser = JSON.parse(window.localStorage.user);
      } catch (e) {
        this.currentUser = null;
      }
    }
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList.some((b) => b.Func === "handleQuery")) {
      this.buttonList.unshift({ name: "查询", Func: "handleQuery", id: 999 });
    }
    if (!this.buttonList.some((b) => b.Func === "exportExcel")) {
      this.buttonList.push({ name: "导出", Func: "exportExcel", id: 998 });
    }
    this.loadCampusOptions();
  },
};
</script>
